var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/cafe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5473,8.5985 C6.7573,8.5985 8.5473,6.8085 8.5473,4.5985 C8.5473,2.3885 6.7573,0.5985 4.5473,0.5985 C2.3373,0.5985 0.5473,2.3885 0.5473,4.5985 C0.5473,6.8085 2.3373,8.5985 4.5473,8.5985",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.302,1.442 C14.512,1.78 13.418,3.247 13.298,4.9 L12.846,13.814 C12.846,13.814 6.081,14.463 2.575,14.814 C0.978,14.973 0.12,16.687 0.497,18.247 C1.617,22.881 4.445,34.215 4.445,34.215 L7.445,34.215 L6.541,20.471 L17.915,21.365 C19.939,21.365 21.165,18.311 20.778,15.77 L18.697,0.963 L16.302,1.442 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9848,8.0047 C7.1948,8.0047 8.9848,6.2147 8.9848,4.0047 C8.9848,1.7947 7.1948,0.0047 4.9848,0.0047 C2.7748,0.0047 0.9848,1.7947 0.9848,4.0047 C0.9848,6.2147 2.7748,8.0047 4.9848,8.0047",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.997,4.216 C1.554,8.495 3.997,21.215 3.997,21.215 L19.997,21.215 L26.997,34.215 L30.997,34.215 L24.996,15.215 L13.996,14.215 L12.27,10.215 L22.424,10.215 C23.292,10.215 23.996,9.511 23.996,8.644 C23.996,7.834 23.381,7.157 22.573,7.079 L13.518,6.215 L7.92,1.357 C7.023,0.529 5.906,0.086 4.487,0.086 C2.557,0.086 0.667,1.692 0.997,4.216 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/cafe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#313036",
    points: "38.996 72.0007 40.996 72.0007 40.996 49.0007 38.996 49.0007"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#5C5C67",
    points: "30.996 49.9997 48.996 49.9997 48.996 47.9997 30.996 47.9997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#D9CA45",
    points: "39.9968 8.0001 14.9968 19.0001 64.9958 19.0001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9965,18.9998 C64.9965,21.7618 62.7575,23.9998 59.9965,23.9998 C57.2345,23.9998 54.9965,21.7618 54.9965,18.9998 C54.9965,21.7618 52.7575,23.9998 49.9965,23.9998 C47.2345,23.9998 44.9965,21.7618 44.9965,18.9998 C44.9965,21.7618 42.7575,23.9998 39.9965,23.9998 C37.2345,23.9998 34.9965,21.7618 34.9965,18.9998 C34.9965,21.7618 32.7575,23.9998 29.9965,23.9998 C27.2345,23.9998 24.9965,21.7618 24.9965,18.9998 C24.9965,21.7618 22.7575,23.9998 19.9965,23.9998 C17.2345,23.9998 14.9965,21.7618 14.9965,18.9998 L64.9965,18.9998 Z",
    id: "Fill-4",
    fill: "#A47F08"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(55.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9965,14.9998 C4.0155,12.0878 2.2425,6.0038 1.4645,1.7588 C2.4695,0.6768 3.9035,-0.0002 5.4965,-0.0002 C8.5335,-0.0002 10.9965,2.4618 10.9965,5.4998 L10.9965,14.9998 Z",
    id: "Fill-6",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-11",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#775823",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8646,0.3778 C2.8956,2.8808 4.5896,5.9728 7.5336,7.7398 L10.5146,1.0038 L1.8646,0.3778 Z",
    fill: "#010202",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.9965,6.4486 C5.9965,5.8966 5.5485,5.4486 4.9965,5.4486 C4.4435,5.4486 3.9965,5.8966 3.9965,6.4486 C3.9965,7.0006 4.4435,7.4486 4.9965,7.4486 C5.5485,7.4486 5.9965,7.0006 5.9965,6.4486",
    id: "Fill-14",
    fill: "#775823"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(44.000000, 37.784700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-26",
    fill: "#DEDFE1",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6029,0.9676 C14.3079,1.3136 10.1799,3.0176 10.1799,3.0176 L5.2359,18.4396 L14.0419,17.3946 L16.6029,0.9676 Z",
    id: "Fill-19",
    fill: "#9A9CA0",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#775823",
    mask: "url(#mask-4)",
    points: "8.9965 20.2151 7.9965 13.2151 -3.0425 12.2511 1.6205 36.0001 11.3815 35.6551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3519,16.9725 L5.6019,18.6635 C4.5799,19.6515 4.0219,21.0255 4.0679,22.4465 L4.4449,34.2155 L7.1149,34.1945 L7.3519,16.9725 Z",
    id: "Fill-25",
    fill: "#63491C",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.8461,43.4486 L62.9961,43.4486 C62.9961,43.4486 61.5511,50.0016 61.1011,52.1926 C60.8521,53.4016 59.5651,53.6666 58.6121,53.1166 L50.6891,48.2406 C50.1671,47.9396 49.9941,47.2696 50.3051,46.7536 C50.5961,46.2716 51.2091,46.0946 51.7121,46.3486 L58.8611,49.8456 L59.8461,43.4486 Z",
    id: "Fill-29",
    fill: "#775823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9965,43.4486 C61.4385,43.7606 60.3115,44.4506 59.5295,45.5076 L59.8465,43.4486 L62.9965,43.4486 Z",
    id: "Fill-31",
    fill: "#63491C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5707073,60.3937142 C63.2983792,60.4299148 63.0205202,60.4486 62.7383,60.4486 L50.2953,60.4486 L50.2953,57.4486 C50.2953,55.2396 52.0863,53.4486 54.2953,53.4486 L61.3573,53.4486 C62.3103,53.4486 63.1303,52.7756 63.3173,51.8416 L64.2113,47.3716 C64.6673,45.0906 66.6703,43.4486 68.9963,43.4486 L68.9963,54.1906 C68.9963,56.3635342 67.8886213,58.277931 66.207155,59.3998991 L68.9965,72.0003 L66.9965,72.0003 L63.5707073,60.3937142 Z M50.295,72.0007 L50.295,60.4487 L52.295,60.4487 L52.295,72.0007 L50.295,72.0007 Z",
    id: "Shape",
    fill: "#C8A81D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9965,29.9998 L22.4365,29.9828 L23.2265,29.3218 C22.1965,27.6988 20.7135,27.0038 18.8845,27.0038 C16.4145,27.0038 14.4145,29.0048 14.4145,31.4738 C14.4145,33.6398 15.9525,35.4428 17.9965,35.8538 L17.9965,29.9998 Z",
    id: "Fill-37",
    fill: "#6C654F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-40",
    transform: "translate(14.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFC59C",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9965,7.9998 L3.9965,3.9998 C3.9965,2.8958 4.8925,1.9998 5.9965,1.9998 L8.9965,1.9788 C8.9965,1.9998 9.0225,0.6888 9.0005,-0.9312 C8.9835,-2.1372 -5.9995,-0.5592 -5.9995,2.4788 C-5.9995,5.5168 -0.0375,9.9788 3.0005,9.9788 L4.4845,7.9998 L3.9965,7.9998 Z",
    fill: "#6C654F",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#313036",
    points: "36.9965 56.9998 31.9965 71.9998 28.5995 72.0048 28.9965 56.9998"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    transform: "translate(12.000000, 37.784700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-55",
    fill: "#53535C",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "-",
    fill: "#5EDBEE",
    mask: "url(#mask-8)",
    points: "13.9965 14.2151 3.7315 24.4001 -1.0035 -0.6379 10.0665 -0.1859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0035,-1.7849 C-0.0035,-1.7849 3.9965,-1.0539 2.6685,0.5861 C1.2035,2.3921 2.2495,4.6311 4.0285,5.6771 C5.2625,6.4031 12.2695,10.2151 12.2695,10.2151 L15.2035,13.0791 L5.9305,22.0791 L-0.3435,2.7331 L-0.0035,-1.7849 Z",
    id: "Fill-51",
    fill: "#16A7C3",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#EFC59C",
    mask: "url(#mask-8)",
    points: "24.9965 11.2151 12.2695 10.2151 7.4155 7.5691 11.5835 2.9641 24.9965 6.2151"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.785845,59.3998991 C12.1043787,58.277931 10.9967,56.3635342 10.9967,54.1906 L10.9967,43.4486 C13.3217,43.4486 15.3247,45.0906 15.7807,47.3716 L16.6747,51.8416 C16.8617,52.7756 17.6817,53.4486 18.6357,53.4486 L25.6967,53.4486 C27.9057,53.4486 29.6967,55.2396 29.6967,57.4486 L29.6967,60.4486 L17.2547,60.4486 C16.9724798,60.4486 16.6946208,60.4299148 16.4222927,60.3937142 L12.9965,72.0003 L10.9965,72.0003 L13.785845,59.3998991 Z M27.697,72.0007 L27.697,60.4487 L29.697,60.4487 L29.697,72.0007 L27.697,72.0007 Z",
    id: "Shape",
    fill: "#C8A81D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9945,44.0072 L41.9965,44.0072 L41.9965,47.0002 C41.9965,47.5522 42.4435,48.0002 42.9965,48.0002 L44.9945,48.0002 C45.5465,48.0002 45.9945,47.5522 45.9945,47.0002 L45.9945,44.0072 Z",
    id: "Fill-62",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4945,47.0072 C47.3225,47.0072 47.9945,46.3352 47.9945,45.5072 C47.9945,44.6782 47.3225,44.0072 46.4945,44.0072 L45.9945,44.0072 L45.9945,47.0072 L46.4945,47.0072 Z",
    id: "Fill-63",
    fill: "#BEC0C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.a41a16e798c74e1226bb12acb7816a3c.svg";
export { ForwardRef as ReactComponent };